
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Login.css'; // Reusing Login styles for consistency

const ForgotPassword = () => {
    const [email, setEmail] = useState('');
    const [submitted, setSubmitted] = useState(false);

    const handleSubmit = (e) => {
        e.preventDefault();
        // Mock password reset logic
        console.log('Reset password for:', email);
        setSubmitted(true);
    };

    return (
        <div className="login-container">
            <div className="login-card">
                <div className="login-header">
                    <h1>Reset Password</h1>
                    <p>Enter your email to receive reset instructions</p>
                </div>

                {!submitted ? (
                    <form className="login-form" onSubmit={handleSubmit}>
                        <div className="form-group">
                            <label>Email Address</label>
                            <input
                                type="email"
                                placeholder="name@company.com"
                                className="form-input"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                            />
                        </div>

                        <button type="submit" className="login-btn">
                            Send Reset Link
                        </button>
                    </form>
                ) : (
                    <div className="login-form">
                        <div style={{ color: '#059669', background: '#ecfdf5', padding: '12px', borderRadius: '8px', fontSize: '14px' }}>
                            If an account exists for {email}, we have sent password reset instructions.
                        </div>
                    </div>
                )}

                <div className="login-footer">
                    <Link to="/login">Back to Login</Link>
                </div>
            </div>
        </div>
    );
};

export default ForgotPassword;
